
import {
  AfterContentInit,
  Component,
  computed,
  ContentChildren,
  input,
  model,
  QueryList
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocalStorageKeys } from '@shared-utils';
import { Visits } from '@types-lib';
import { SortableDataArray, sortData, SortOrder } from './helpers/local-data-sorting';
import { SortableDataKeys } from './helpers/local-data-sorting.model';
import { SkeletonTableBodyComponent } from './skeleton-table-body/skeleton-table-body.component';
import { TablePaginationComponent } from './table-pagination/table-pagination.component';

@Component({
    selector: 'lib-table',
    imports: [
    FormsModule,
    TablePaginationComponent,
    SkeletonTableBodyComponent
],
    templateUrl: './table.component.html',
    styleUrl: './table.component.scss'
})
export class TableComponent implements AfterContentInit {
  savePageLocalStorageKey = input.required<LocalStorageKeys>();
  isLoading = input.required<boolean>();
  localSort = input.required<boolean>();
  data = input<SortableDataArray<SortableDataKeys>>();
  dataType = input<SortableDataKeys>();
  sortSettings = input<SortOrder>();
  pagination = model<Visits.BasePagination>();
  availableLimits = input<string | number[]>();
  itemsPerPageOptions = input.required<string | number[]>();
  noDataMessage = input('No data to display');
  paginated = input.required<boolean>();

  private defaultRows = 25;

  @ContentChildren('header', { descendants: true }) tableHeaders!: QueryList<unknown>;
  @ContentChildren('row', { descendants: true }) tableRows!: QueryList<unknown>;

  public localSorting = computed(() => {
    if (!this.localSort()) {
      return {
        errorMessage: '',
        sortedData: this.data() || [],
      };
    }
    const dataType = this.dataType();
    const data = this.data();
    const sortSettings = this.sortSettings();
    if (!dataType || !data || !sortSettings?.sortBy || !sortSettings?.sortDirection) {
      const error = `Missing required properties for sorting:
      dataType, data, sortBy, and sortDirection must all be provided when sorting is enabled!`;
      console.error(error);
      return {
        errorMessage: error,
        sortedData: data || [],
      };
    }
    const sorted = sortData(dataType, data, sortSettings.sortBy, sortSettings.sortDirection);

    return {
      errorMessage: '',
      sortedData: sorted,
    };
  });

  public skeletonCells: number[] = [];
  public skeletonRows: number[] = [];

  ngAfterContentInit() {
    this.skeletonCells = Array(this.tableHeaders.length);
    const paginationLimit = this.pagination()?.limit;
    const numberOfRows = this.tableRows.length
      ? this.tableRows.length
      : paginationLimit
      ? paginationLimit
      : this.defaultRows;
    this.skeletonRows = Array(numberOfRows);
  }

  paginationChange(event?: Visits.BasePagination) {
    if (event) {
      this.pagination.set(event);
    }
  }
}
